import {UI} from "stem-core/ui/UIBase";
import {MerchantStaffList} from "./MerchantStaffList.jsx";
import {EditableCard} from "../ui/EditableCard.jsx";
import {type AdminMerchant, apiAdminFetchMerchant, apiUpdateMerchant} from "../../../client/state/merchant/AdminMerchantStore.js";
import {apiAdminUpdateMerchantFees, type AdminUpdateMerchantFeesRequest} from "../../../client/state/merchant/MerchantFeesStore.js";
import {loadBefore} from "../../../blinkpay/ui/decorators/LoadBefore.jsx";
import {DashboardTitle} from "../../../dashboard/common/DashboardTitle.js";
import {SubscriptionOffer} from "../../../client/state/SubscriptionOfferStore.js"; // Import for store

async function loadMerchant(options: Record<string, any>) {
    const merchantId = options.args[0];
    options.merchant = await apiAdminFetchMerchant(merchantId);
}

interface MerchantPanelOptions {
    merchant?: AdminMerchant;
    title?: string;
}

class MerchantPanel extends UI.Element<MerchantPanelOptions> {
    render() {
        const {merchant} = this.options;
        const merchantFees = merchant.getFees();

        return [
            <div style={{fontSize: 18, padding: 8}}>
                Legal Entity: {merchant.legalEntity}
            </div>,
            <EditableCard values={merchant}
                          title="Merchant Profile"
                          editableFields={["name", "alias", "url", "wideLogoUrl", "cardStatementName", "allowPurchases", "allowSubscriptions", "allowDonations"]}
                          onUpdate={(data) => apiUpdateMerchant({merchantId: merchant.id, ...data})}
            />,
            <EditableCard values={merchantFees}
                          title="Merchant Fees"
                          editableFields={["purchaseFee", "subscriptionFee", "donationFee"]}
                          // The card answers with the editable fields filtered off the fees object, so all
                          // three fees are there; its values are typed only as a string-keyed bag
                          onUpdate={(data) => apiAdminUpdateMerchantFees({merchantId: merchant.id, ...data} as AdminUpdateMerchantFeesRequest)}
            />,
            <MerchantStaffList merchant={merchant}/>,
        ]
    }
}


interface MerchantPageOptions {
    merchant?: AdminMerchant;
}

@loadBefore(loadMerchant)
export class MerchantPage extends UI.Element<MerchantPageOptions> {
    render() {
        const {merchant} = this.options;

        return [
            <DashboardTitle title={"Edit merchant " + merchant.name}/>,
            <MerchantPanel title="Merchant" merchant={merchant}/>
        ];
    }
}
